<div class="crew-flyout" *ngIf="crew" [ngClass]="'rarity-' + crewRarity(crew).toLowerCase()">
  <div class="crew-flyout-header">
    <pss-sprite class="crew-avatar" *ngIf="crewSpriteId(crew)" [spriteId]="crewSpriteId(crew)"></pss-sprite>
    <span class="crew-name" [class]="'rarity-' + crewRarity(crew).toLowerCase()">{{ crewName(crew) }}</span>
  </div>
  <div class="crew-flyout-row"><span>Level</span><span>{{ crew.level }}</span></div>
  <div class="crew-flyout-row"><span>XP</span><span>{{ crew.xp }}</span></div>

  <div class="crew-modal-section-title">Stats</div>
  <div class="crew-flyout-stats-grid">
    <div><span>HP</span><span>{{ crewBaseStat(crew,'hpImp') | number:'1.0-0' }}</span></div>
    <div><span>PLT</span><span>{{ crewBaseStat(crew,'pilotImp') | number:'1.0-0' }}</span></div>
    <div><span>ATK</span><span>{{ crewBaseStat(crew,'attackImp') | number:'1.0-0' }}</span></div>
    <div><span>SCI</span><span>{{ crewBaseStat(crew,'scienceImp') | number:'1.0-0' }}</span></div>
    <div><span>RPR</span><span>{{ crewBaseStat(crew,'repairImp') | number:'1.0-0' }}</span></div>
    <div><span>ENG</span><span>{{ crewBaseStat(crew,'engineImp') | number:'1.0-0' }}</span></div>
    <div><span>ABL</span><span>{{ crewBaseStat(crew,'abilityImp') | number:'1.0-0' }}</span></div>
    <div><span>WPN</span><span>{{ crewBaseStat(crew,'weaponImp') | number:'1.0-0' }}</span></div>
    <div><span>STA</span><span>{{ crew.stamina || '0' }}</span></div>
    <div><span>RST</span><span>{{ crew.fatigue || '0' }}</span></div>
    <div><span>WLK</span><span>{{ crew.walk || '0' }}</span></div>
    <div><span>RUN</span><span>{{ crew.run || '0' }}</span></div>
  </div>

  <div class="crew-flyout-row crew-flyout-total"><span>Status</span><span>Stash</span></div>
  <div class="crew-flyout-row crew-flyout-total" *ngIf="equipmentList(crew).length"><span>Gear</span><span>{{ equipmentList(crew).length }} items</span></div>
  <button class="crew-flyout-close" (click)="close.emit()">Close</button>
</div>
